import { useState, type ReactNode } from 'react';

import { IconButton } from '../../ui/controls.js';

/** Preview area with an expand / shrink button. */
export function PreviewFrame({ children }: { children: ReactNode }) {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className={`gen-pv${expanded ? ' gen-pv-expanded' : ''}`}>
      {children}
      <IconButton
        className="gen-pv-expand"
        icon="fullscreen"
        size={13}
        active={expanded}
        title={expanded ? 'Smaller preview' : 'Larger preview'}
        onClick={() => setExpanded((v) => !v)}
      />
    </div>
  );
}
